import { render } from "./bbProductManage.vue?vue&type=template&id=7b984617"
import script from "./bbProductManage.vue?vue&type=script&lang=jsx"
export * from "./bbProductManage.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__